import { LitElement,  TemplateResult, property, customElement, css } from 'lit-element';
import {html, render} from 'lit-html';
import {storeInstance} from "store/index.js";
import "@ui5/webcomponents/dist/List.js";
import "@ui5/webcomponents/dist/StandardListItem.js";
import "@ui5/webcomponents/dist/Popover.js";
import { Router } from '@vaadin/router/dist/vaadin-router.js';

class KbParentpath extends (LitElement)   {
    constructor(){
        super();
       }    

    connectedCallback(){
        this.subscription = storeInstance.subscribe(state => {
            this.stateChange(state);
        });
        this.state = storeInstance.state
        this.string = this.state.strings;
    }

    disconnectedCallback() {
        storeInstance.unsubscribe(this.subscription)
    }

    
    set params(value) {
        this.langCode = value.langCode;
        if(value.extId!=this.externalId){
            this.externalId = value.extId;
            storeInstance.dispatch("getParentPath",{extId: this.externalId, langcode: this.langCode});
        }
      }
    
    stateChange(state){
        this.state = state;
        this.string = this.state.strings;
        if(this.state.item_parentpath){
            this.parents=[];
            this._preparePath(this.state.item_parentpath)
        }
        this.myRender()
        }

    _preparePath(node){
        if(node.itemLang){
            var itm = {}
            if(node.itemLang.name=='Root Item'){
                itm.name = 'Home'
            } else {
                itm.name =  node.itemLang.name
            }
            itm.item = node
            this.parents.unshift(itm)
            if(node.parentNode){
              this._preparePath(node.parentNode)
            }
          }
    }
    _buildLinks(){
        for(var i = 0;i<this.parents.length;i++){
          var el = document.createElement("LI")
          el.innerText = this.parents[i].name;
          var att = document.createAttribute("item");
          el.setAttributeNode(att) 
          var el2 = this.$.parentpaths.appendChild(el)
          el2.addEventListener('click', this._parentClick.bind(this));
          el2.item = this.parents[i].item;
        }
      }
  
    myRender(){
        render(this.pathBreadcrumbTemplate(), this.shadowRoot);
        }
     
        
    pathBreadcrumbTemplate(){
        return html`
        <style>
            #paths{
                color: var(--kb-on-surface-color);
            }
            #paths ul{
                list-style:none;
            }
            #paths li{
                display:inline;
                margin-right:1rem;
                cursor: pointer;
                color: var(--kb-primary-color);
                text-decoration: underline;
            }
        </style>
        <div id='paths'>  
            <ul>
            ${this.parents.map((item) => 
                html`<li @click="${this._gotoItem.bind(this,item)}">${item.name}</li>`
                 )}
            <ul>
        </div>
        `;
 
    }
    
    _gotoItem(item,e){
        Router.go("/kb/" + this.state.langCode + "/" + item.item.item.externalId)
    }


}

customElements.define('kb-parentpath', KbParentpath)
